<template>
    <div id="solution_type_text" class="px-3 px-sm-0">
        <v-textarea
            required
            filled
            :rows="rows"
            auto-grow
            v-model="val"
            :placeholder="placeholder"
            rounded
            :disabled="hasUserInput"
            :class="{ correctAnswer: correctAnswer, wrongAnswer: wrongAnswer }"
        ></v-textarea>
    </div>
</template>

<script>
import { layoutMixin } from '@/utils/layout-mixin';
import { solutionMixin } from '@/utils/solution-mixin';
export default {
    mixins: [layoutMixin, solutionMixin],
    props: {
        spot: {},
        rows: {
            type: Number,
            default: 1
        },
        placeholder: {
            type: String,
            default: ''
        },
        borderColor: {}
    },
    data() {
        return {
            val: null,
            correctAnswer: false,
            wrongAnswer: false,
            borderColorValue: this.borderColor
        };
    },
    created() {
        this.checkIfAnswerIsCorrect();
        this.assignPseudoElementStyle();
    },
    computed: {},
    watch: {
        /* Init data on creation and on update */
        spot: {
            handler() {
                if (this.hasUserInput) {
                    this.val = this._.isArray(this.userInput) ? this._.first(this.userInput) : this.userInput;
                }
            },
            immediate: true,
            deep: true
        },
        val(text) {
            this.$emit('input', text, this.getServerData(text));
        }
    },
    methods: {
        checkIfAnswerIsCorrect() {
            if (this.spot.raetsel.user_input.length > 0) {
                if (this.spot.tstatus === 3) {
                    this.correctAnswer = true;
                } else if (this.spot.tstatus === 4) {
                    this.wrongAnswer = true;
                }
            }
        },
        assignPseudoElementStyle() {
            this.borderColorValue = this.theme.textColor;
            document.documentElement.style.setProperty('--border-color', this.borderColorValue);
        }
    }
};
</script>

<style lang="scss">
#solution_type_text {
    textarea {
        color: var(--border-color);
        caret-color: var(--border-color);
    }
    .v-input {
        border: 2px solid transparent;
        height: auto;
        border-color: var(--border-color);
        .v-input__slot {
            margin-bottom: -22px !important;
        }
        ::placeholder {
            color: var(--border-color);
            opacity: 0.5;
        }
    }
    .correctAnswer {
        border-color: #8ce9bd;
    }
    .wrongAnswer {
        border-color: #d6787d;
    }
    textarea::placeholder {
        color: var(--border-color);
    }
}
</style>
